import { AnalyticsService } from './../analytics/analytics.service';
import { RegistryService } from './../registry/registry.service';
import { Registry } from './../registry/registry';
import { Intercom } from 'ng-intercom';
import { CustomValidatorsService } from './../shared/validators.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from './../unsplash/unsplash.response';
import { AuthService } from './../user/auth.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ISubscription } from 'rxjs/Subscription';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { HttpService } from '../shared/http.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit, OnDestroy {
  hitchdForm: FormGroup;
  subscription: ISubscription;
  errorMessage: string;
  submitting = false;
  socialSubmitting = false;
  verified = false;
  currency: string = "USD"
  country: string = "US"
  constructor(public _authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private _intercom: Intercom,
    private _registryService: RegistryService,
    private _analyticsServices: AnalyticsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _http: HttpService,
  ) {

    document.title = 'Log in | Hitchd';
    this.activatedRoute.data.subscribe((data: Params) => {
      const verified = data['verified'];

      if (verified) {
        this.verified = true;
      }
    });

  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  signInFacebook() {
    this.socialSubmitting = true;
    this._authService.facebookLogin().then(x => {


      this._authService.user.take(1).subscribe(user => {
        //
        if (user != null) {
          //


          if (!this._analyticsServices.skipEuMarketing){
            this._registryService.sendFbTrackEvent('Logged in');
          this._intercom.boot({ email: user.email, user_id: user.uid, name: null });
          }

          this._analyticsServices.identifySegmentUser(user);
          if (user.registryId) {
            this.router.navigate(['/registry']);
          } else {
            this.router.navigate(['/get-started']);
          }
        } else {
          this.socialSubmitting = false;
        }

      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {

          this.errorMessage = 'This account was setup with a different sign in method, please try again';
        }
        this.socialSubmitting = false;
      });
  }


  signInGoogle() {
    this.socialSubmitting = true;
    this._authService.googleLogin().then(x => {

      this._authService.user.take(1).subscribe(user => {
        //
        if (!this._analyticsServices.skipEuMarketing){
        this._intercom.boot({ email: user.email, user_id: user.uid , name: null});

        this._registryService.sendFbTrackEvent('Logged in');
      }

      this._analyticsServices.identifySegmentUser(user);
        this.submitting = false;
        if (user != null) {
          if (user.registryId) {
            this.router.navigate(['/registry']);
          } else {
            this.router.navigate(['/get-started']);
          }
        } else {
          this.socialSubmitting = false;
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'This account was setup with a different sign in method, please try again';
        }
        this.submitting = false;
      });
  }


  ngOnInit() {
    this.hitchdForm = this._fb.group({
      email: ['', [Validators.required, this._validatorService.validateEmail]],
      password: ['', [Validators.required]],
    });
    const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove();
    }



  }


  submit() {
    this.errorMessage = '';
    this.submitting = true;
    if (this.hitchdForm.valid) {
      const email = this.hitchdForm.controls['email'].value;
      const password = this.hitchdForm.controls['password'].value;
      this._authService.login(email, password)
        .catch(
          (e: Error) => {
            if (e.message === 'authError') {
              this.errorMessage = 'The Email or Password entered is incorrect';
            }
            
             if (e.message === 'auth/too-many-requests') {
              this.errorMessage = 'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.';
             }

            console.log(e);


            this.submitting = false;
          }
        ).then(x => {

          this._authService.user.take(1).subscribe(user => {
            
            if (user === undefined) {


            }
       
            if (user != null) {
              //

              this._analyticsServices.identifySegmentUser(user);
              if (!this._analyticsServices.skipEuMarketing){

                this._registryService.sendFbTrackEvent('Logged in');
                this._intercom.boot({ email: user.email, user_id: user.uid , name: null});
              }

              if (user.registryId) {
                this.router.navigate(['/overview']);
              } else {


                let form:any = {};
                form.guestCount = null;
                form.backgroundHeaderVideoUrl = 'https://player.vimeo.com/external/532665758.hd.mp4?s=7c587f986e25ae587ae8967d990061f5c15ab50b&profile_id=175&oauth2_token_id=57447761'
                form.backgroundHeaderImageUrl = 'https://images.pexels.com/videos/7385122/4k-background-loop-ocean-7385122.jpeg?hex=232D2F';
                form.introTitle = 'Welcome to our registry';
                form.introductionText = 
                'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
                form.symbol = "$";
                form.currency = this.currency;
                form.symbol = "$"
                form.firstName = "You",
                form.partnerFirstName = "Fiance",
                form.isRecoveedViaAutoHeal = true;
                form.country = this.country;
                form.registryName =  this._registryFirebaseService.generateUniqueUrlPath()
                form.showRecommendedAmount = false;
                const campaign = localStorage.getItem('utm_campaign');
                const referal_user_id = localStorage.getItem('referal_id');
                const source = localStorage.getItem('utm_source');
                const landingPage = localStorage.getItem('landingPage');
                const partnershipId = localStorage.getItem('partnershipId');
                if (landingPage) {
                  form.landingPage = landingPage;
            
                }
                if (source) {
                  form.source = source;
                }
                if (campaign) {
                  form.campaign = campaign;
                }
                if(referal_user_id){
                  form.referalUserId = referal_user_id;
                }
            
            
            
            if (partnershipId) {
                  form.partnershipId = partnershipId;
                }
            
                this._analyticsService.update({ campaign: campaign, source: source, landingPage: landingPage  });
   
            
            
                form.email = null;
                form.password = null;
                form.userId = user.uid;
                const formValue: any = JSON.stringify(form);
            
                localStorage.setItem('tempReg', formValue);
                localStorage.removeItem("dismiss_reg_setup");
                this._registryFirebaseService.createRegistry(formValue, user).then(x => {
                  this.router.navigate(['/overview']);
                })
              


                console.log("login failed user - no reg data found, healing registry" + user)
                //return window.location.reload();
              }
              this.submitting = false;
            }
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/signin/signin.component.ts